import { Spacing } from "goi_common";

import PriceTable from "@/components/table/PriceTable";

interface RefundCalculatorResultProps {
  price?: number;
}

const RefundCalculatorResult = ({ price = -1 }: RefundCalculatorResultProps) => {
  const tableHeader = {
    key: "예상 환급 금액",
    value: `${price?.toLocaleString()}원`,
  };

  const tableRows = [
    {
      key: "* 위 금액은 실제 환급 금액과 다를 수 있습니다.",
      value: "",
    },
  ];

  if (price >= 0) {
    return (
      <>
        <Spacing gap={28} />
        <PriceTable header={tableHeader} rows={tableRows} />
        <Spacing gap={28} />
      </>
    );
  }

  return null;
};

export default RefundCalculatorResult;
